import { GoogleMap, LoadScript, DirectionsRenderer, Polyline, Marker } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import { directionsKey } from '../../../../../../Config';

export default function GoogleMapComponent({ pickupPlaceId, dropPlaceId, setAdditionalDirectionData }) {
  const [directionsResponse, setDirectionsResponse] = useState<google.maps.DirectionsResult | null>(null);
  const [center, setCenter] = useState<google.maps.LatLngLiteral>({
    lat: 28.5173696,
    lng: 77.2274638, // Default center
  });
  const [routePath, setRoutePath] = useState<google.maps.LatLngLiteral[]>([]);
  const [location, setLocation] = useState<google.maps.LatLngLiteral | null>(null);

  const fetchDirections = async () => {
    console.log('Fetching directions...');
    setCenter({
      lat: pickupPlaceId?.geometry?.location?.lat,
      lng: pickupPlaceId?.geometry?.location?.lng,
    });
    setLocation({
      lat: pickupPlaceId?.geometry?.location?.lat,
      lng: pickupPlaceId?.geometry?.location?.lng,
    });
    setDirectionsResponse(null);
    let directionsService;
    if (window.google && window.google.maps) {
      directionsService = new window.google.maps.DirectionsService();
    }
    directionsService?.route(
      {
        origin: pickupPlaceId
          ? {
              lat: pickupPlaceId?.geometry?.location?.lat,
              lng: pickupPlaceId?.geometry?.location?.lng,
            }
          : { lat: 0, lng: 0 },
        destination: dropPlaceId
          ? {
              lat: dropPlaceId?.geometry?.location?.lat,
              lng: dropPlaceId?.geometry?.location?.lng,
            }
          : { lat: 0, lng: 0 },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result: google.maps.DirectionsResult | null, status) => {
        if (status === window.google.maps.DirectionsStatus.OK && result) {
          setDirectionsResponse(result);
          const route = result.routes[0].overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng(),
          }));

          const startLocation = result.routes[0].legs[0].start_location;

          setAdditionalDirectionData({
            // @ts-ignore
            start_lat_lon: result?.routes[0]?.legs?.start_location,
            // @ts-ignore
            end_lat_lon: result?.routes[0]?.legs?.end_location,
            // @ts-ignore
            duration: result?.routes[0]?.legs[0]?.duration?.value,
            // @ts-ignore
            distance: result?.routes[0]?.legs[0]?.distance?.value,
            distanceUnit: 'met',
            overviewPolyline: result?.routes?.[0]?.overview_polyline,
            travelMode: result?.request?.travelMode,
          });
          setRoutePath(route);
        } else {
          console.error(`Error fetching directions: ${status}`);
        }
      },
    );

    console.log('directionserives', directionsService);
  };

  useEffect(() => {
    if (!pickupPlaceId && !dropPlaceId) {
      setDirectionsResponse(null);
      return;
    }
    if (pickupPlaceId?.geometry?.location?.lat && pickupPlaceId?.geometry?.location?.lng) {
      setCenter({
        lat: pickupPlaceId?.geometry?.location?.lat,
        lng: pickupPlaceId?.geometry?.location?.lng,
      });
    } else if (pickupPlaceId?.place_id) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ placeId: pickupPlaceId?.place_id }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK && results?.[0]) {
          const { lat, lng } = results[0]?.geometry?.location;
          setCenter({ lat: lat(), lng: lng() });
        }
      });
    }

    fetchDirections();
  }, [pickupPlaceId?.place_id, dropPlaceId?.place_id]);

  console.log('hello place', {
    pickupPlaceId,
    dropPlaceId,
  });

  return (
    <div className="google-map">
      <LoadScript
        googleMapsApiKey={`${directionsKey}`}
        // googleMapsApiKey={`AIzaSyCEqU4YGzPGLV8M0b5dSt5ZY4tm1wpQSDk`}
        onLoad={() => {
          console.log('Google Maps API loaded', pickupPlaceId, dropPlaceId);
          if (pickupPlaceId && dropPlaceId) {
            fetchDirections();
          }
        }}
      >
        <GoogleMap
          key={`${pickupPlaceId?.place_id}-${dropPlaceId?.place_id}`}
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={center} // Use dynamic center state
          zoom={15}
          options={{
            fullscreenControl: false,
            mapTypeControl: false,
            scrollwheel: false,
            streetViewControl: false,
          }}
        >
          {directionsResponse && (
            <>
              <DirectionsRenderer directions={directionsResponse} options={{ suppressPolylines: true }} />
              <Polyline
                path={routePath}
                options={{
                  strokeColor: '#0F53FF',
                  strokeOpacity: 1,
                  strokeWeight: 6,
                }}
              />
            </>
          )}

          {!directionsResponse && location && <Marker position={location} />}
          {/* {location && placeId && <Marker position={location} />} */}
        </GoogleMap>
      </LoadScript>
    </div>
  );
}
